import React from "react";
import { useNavigate } from "react-router-dom";
import { Handshake, CheckCircle2, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ForAgencies() {
  const nav = useNavigate();
  return (
    <div className="max-w-6xl mx-auto px-6 py-16">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0088FF]/10 text-[#0088FF] text-xs font-medium mb-5">
        <Handshake className="h-4 w-4" /> For Recruiting Agencies & Agents
      </div>
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <h1 className="font-display text-4xl font-extrabold text-[#0A192F]">Partner with Emira. Grow your placements.</h1>
          <p className="text-slate-600 mt-4 leading-relaxed">
            Register your agency to access assigned jobs, submit and manage candidates, track recruitment
            stages and view your commission — all from one secure portal. Your candidate data stays fully
            isolated and private to your agency.
          </p>
          <ul className="mt-6 space-y-3">
            {["Access assigned international jobs", "Submit & manage your own candidates", "Track every recruitment stage live", "Transparent commission ledger"].map((t) => (
              <li key={t} className="flex items-center gap-2 text-slate-700"><CheckCircle2 className="h-5 w-5 text-emerald-500" /> {t}</li>
            ))}
          </ul>
          <Button data-testid="agency-register-cta" onClick={() => nav("/register?role=agency")} className="mt-8 bg-[#0088FF] hover:bg-[#0070E0] h-12 px-8">
            Register as Agency
          </Button>
          <p className="text-xs text-slate-400 mt-3">Agencies are reviewed and approved by Emira before operational access is granted.</p>
        </div>
        <div className="brand-gradient-navy rounded-3xl p-8 relative overflow-hidden">
          <div className="absolute inset-0 brand-dotgrid opacity-40" />
          <div className="relative space-y-5">
            {[
              { icon: TrendingUp, t: "Performance tracked", d: "See candidates, selections and deployments in real time." },
              { icon: Handshake, t: "Commission structure", d: "Per-deployment commission auto-calculated on success." },
              { icon: CheckCircle2, t: "Data isolation", d: "Your candidates are never visible to other agencies." },
            ].map((c) => (
              <div key={c.t} className="flex gap-3 bg-white/5 rounded-xl p-4 border border-white/10">
                <div className="h-10 w-10 rounded-lg bg-[#0088FF] grid place-items-center text-white shrink-0"><c.icon className="h-5 w-5" /></div>
                <div><div className="text-white font-semibold">{c.t}</div><div className="text-sm text-slate-300">{c.d}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
